import * as React from 'react';
import { t } from 'i18next';

import { ShareBaseTab } from './ShareBaseTab';
import { LongButton } from '../LongButton';
import { AppHelper } from '../../utils/AppHelper';
import { AppConfigurationStore, DownloadOption } from '../../stores/AppConfigurationStore';
import { ShareButton } from '../ShareButton';
import { ArticleListMaker } from '../../utils/ArticleListMaker';

export class ShareApp extends ShareBaseTab<{}> {
    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }
        return (
            <div className="sidebar-tab-container"><div className="scrollbar-wcf">
                {this.header(t('Open in app'))}
                <div className="sidebar-content">
                    <div className="long-button-group">
                        <LongButton className="short-border" arrow={false} onClick={this.onShareScreenshot}> {t('Image')} </LongButton>
                    </div>
                    <div className="sidebar-subheader">{t('Commercial Information')}</div>
                    <div className="long-button-group">
                        {AppConfigurationStore.getState().articleListTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <ShareButton key={index + '-al'} option={downloadOption} callback={ArticleListMaker.share} hideArrow={true}/>;
                        })}
                        {AppConfigurationStore.getState().commercialDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <ShareButton key={index + '-com'} option={downloadOption} callback={AppHelper.shareLinkContent} hideArrow={true}/>;
                        })}
                    </div>
                    <div className="sidebar-subheader">{t('CAD Symbols')}</div>
                    <div className="long-button-group">
                        {AppConfigurationStore.getState().cadDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                            return <ShareButton key={index + '-cad'} option={downloadOption} callback={AppHelper.shareLinkContent} hideArrow={true}/>;
                        })}
                    </div>
                </div>
            </div></div>
        );
    }

    protected onShareScreenshot = (): void => {
        AppHelper.shareScreenshot();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/ShareApp.tsx